import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Home from './views/Home.vue'
import Production from './views/Production.vue'
import Editorials from './views/Editorials.vue'
import Editorial from './views/Editorial.vue'
// import Staff from './views/Staff.vue'
import Shop from './views/Shop.vue'
import Product from './views/Product.vue'
import Cart from './views/Cart.vue'
import About from './views/About.vue'
import Page from './views/Page.vue'
import Impact from './views/Impact.vue'
import ImpactDetail from './views/ImpactDetail.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (from.hash === '#channels' || savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        selector: to.hash,
        offset: { y: 47 },
      }
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/productions/:production',
      name: 'production',
      component: Production,
    },
    {
      path: '/echoes',
      name: 'editorials',
      component: Editorials,
    },
    {
      path: '/echoes/:editorial',
      name: 'editorial',
      component: Editorial,
      meta: { invert: true },
    },
    {
      path: '/impact',
      name: 'impact',
      component: Impact,
    },
    {
      path: '/impact/:slug',
      name: 'impact-detail',
      component: ImpactDetail,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/shop',
      name: 'shop',
      component: Shop,
    },
    {
      path: '/cart',
      name: 'cart',
      component: Cart,
    },
    {
      path: '/clear-checkout',
      name: 'clear-checkout',
      component: Cart,
    },
    {
      path: '/shop/p/:handle',
      name: 'product',
      component: Product,
    },
    {
      path: '*',
      name: 'page',
      component: Page,
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.hash === '#channels') {
    store.dispatch('setShowChannels', true)
    document.body.style.overflow = 'hidden'
  } else if (from.hash === '#channels') {
    store.dispatch('setShowChannels', false)
    document.body.style.overflow = 'initial'
  }

  next()
})

export default router
